import React from 'react'
import './WhyChooseUs.component.scss'

const stats = [
  {
    value: '38 Years',
    subtitle: 'of experience protecting our customers',
  },
  {
    value: '500+ Agents',
    subtitle: 'licensed & independent in your local area*',
  },
  {
    value: 'Free Consultations',
    subtitle: 'honest guidance at no cost to you',
  },
]

const WhyChooseUs = () => {
  return (
    <section className='why-choose-us'>
      <div className='why-choose-us__inner'>
        <div className='why-choose-us__heading-col'>
          <h2 className='why-choose-us__heading'>
            <span>Why Choose USA Benefits Group</span>
          </h2>
        </div>
        {stats.map(stat => (
          <div key={stat.value} className='why-choose-us__stat-col'>
            <p className='why-choose-us__stat-value'>
              <span>{stat.value}</span>
            </p>
            <p className='why-choose-us__stat-subtitle'>
              <span>{stat.subtitle}</span>
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default WhyChooseUs
